import { Mic, Monitor, Headphones, StopCircle } from 'lucide-react';
const isDisplayCaptureSupported = () =>
  typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getDisplayMedia;

export default function RecordingControls({
  status,
  sourceLabel,
  error,
  onStart,
  onStop,
  engine,
  onEngineChange,
  browserEngineSupported,
  localModelStatus,
  localModelProgress,
  quality,
  onQualityChange,
}) {
  const recording = status === 'recording';
  const requesting = status === 'requesting';
  const isBrowserEngine = engine === 'browser';
  const isLocalEngine = engine === 'local';
  const sourceButtonsDisabled = recording || requesting || isBrowserEngine || !isDisplayCaptureSupported();

  return (
    <div className="recording-controls">
      <div className="engine-toggle">
        <label>
          <input
            type="radio"
            name="engine"
            checked={isLocalEngine}
            disabled={recording || requesting}
            onChange={() => onEngineChange('local')}
          />
          Local (offline, in-browser) — mic, tab &amp; system audio, audio stays on your device; notes sync to your account
        </label>
        <label>
          <input
            type="radio"
            name="engine"
            checked={isBrowserEngine}
            disabled={recording || requesting || !browserEngineSupported}
            onChange={() => onEngineChange('browser')}
          />
          Browser built-in — mic only, Chrome/Edge; audio is processed by the browser’s speech service
        </label>
      </div>

      {isLocalEngine && (
        <div className="recording-quality">
          <label htmlFor="recording-quality">Transcription quality · English</label>
          <select id="recording-quality" value={quality} disabled={recording || requesting || localModelStatus === 'loading'} onChange={(event) => onQualityChange(event.target.value)}>
            <option value="fast">Fast — Whisper Tiny</option>
            <option value="balanced">Balanced — Whisper Base</option>
            <option value="accurate">Higher accuracy — Whisper Small</option>
          </select>
          <p>{quality === 'accurate' ? 'Larger download and slower transcription. Best suited to a desktop; results may arrive after you stop recording.' : quality === 'balanced' ? 'A larger model than Fast, with moderate download and processing requirements.' : 'Smallest download and fastest processing.'} Models download once and are cached on this device.</p>
        </div>
      )}

      {isLocalEngine && localModelStatus === 'loading'  && (
        <p className="recording-status">
          Downloading local model (first run only, cached afterwards)… {localModelProgress}%
        </p>
      )}

      <div className="recording-buttons">
        <button
          className="btn-secondary"
          disabled={recording || requesting}
          onClick={() => onStart('mic')}
        >
          <Mic aria-hidden="true" /> Record microphone
        </button>
        <button
          className="btn-secondary"
          disabled={sourceButtonsDisabled}
          onClick={() => onStart('system')}
          title="Capture audio from a browser tab (e.g. Google Meet) or, on Windows/ChromeOS, entire system audio"
        >
          <Monitor aria-hidden="true" /> Record tab / system audio
        </button>
        <button className="btn-secondary" disabled={sourceButtonsDisabled} onClick={() => onStart('both')}>
          <Headphones aria-hidden="true" /> Record mic + system audio
        </button>
        {recording && (
          <button className="btn-danger" onClick={onStop}>
            <StopCircle aria-hidden="true" /> Stop recording
          </button>
        )}
      </div>

      {requesting && <p className="recording-status">Requesting permissions…</p>}
      {recording && (
        <p className="recording-status recording-live">
          ● Recording ({sourceLabel}) — {error ? 'transcription interrupted' : localModelStatus === 'loading' ? 'loading transcription model…' : 'transcribing automatically…'}
        </p>
      )}
      {error && <p className="recording-error">{error}</p>}
    </div>
  );
}
